import { render, staticRenderFns } from "./RecepcionesActividad.vue?vue&type=template&id=d2e3cd2c&"
import script from "./RecepcionesActividad.vue?vue&type=script&lang=ts&"
export * from "./RecepcionesActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d2e3cd2c', component.options)
    } else {
      api.reload('d2e3cd2c', component.options)
    }
    module.hot.accept("./RecepcionesActividad.vue?vue&type=template&id=d2e3cd2c&", function () {
      api.rerender('d2e3cd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Recepcion/RecepcionesActividad.vue"
export default component.exports